import { createError } from 'h3'
import { useApi } from '@/composables/useApi'
import { useClientStore } from '@/stores/client.store'
import type { ClientDataResponse } from '@/models/Client.model'
import { useGetClientTagFromSubdomain } from '@/composables/useGetClientTagFromSubdomain'

export default defineNuxtRouteMiddleware(async () => {
  const { get } = useApi()
  const clientStore = useClientStore()

  const { getClientTagFromSubdomain } = useGetClientTagFromSubdomain()
  const clientTag = getClientTagFromSubdomain()

  if (!clientTag) {
    return
  }

  try {
    const { success, data } = await get<ClientDataResponse>(`/client/${clientTag}/data`)
    if (success) {
      const { clientUuid, colors, currency, logo, legalTexts } = data

      clientStore.setClientUuid(clientUuid)
      clientStore.setCurrency(currency)
      clientStore.setColors(colors)
      clientStore.setLogo(logo)
      clientStore.setLegalContent(legalTexts)
    }
  }
  catch {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
})
